import { Component, Input, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { EFundStatus, FundTypeEnum, OpportunityItemDto } from 'src/app/core/data-models/opportunity.data.models';
import { LanguageService } from '../../services/language.service';
import { AppTheme, TenantConfigService } from '../../services/tenant-config.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-opportunity-card',
  templateUrl: './opportunity-card.component.html',
  styleUrls: ['./opportunity-card.component.css']
})
export class OpportunityCardComponent {
  @Input() opportunity!: OpportunityItemDto;
  public fundStatusLabel!: string;
  @Input() filterFundStatus?: EFundStatus;
  fundStatus = EFundStatus;
  fundTypes = FundTypeEnum;
  color: ThemePalette = 'primary';
  mode: ProgressBarMode = 'determinate';
  opportunityStatus!: EFundStatus;
  shortFundType!: string;
  shortStatus!: string;
  formattedRoi!: string;
  defaultOpportunityImageUrl: string = '';
  tenantId: string = '';
  opportunityTheme: AppTheme = AppTheme.CLASSIC;
  opportunityThemes = AppTheme;
  fundTitleFontSize!: string;
  classicFundTitleFontSize!: string;
  @ViewChild('filterDialogRef') filterDialogRef!: TemplateRef<any>;

  constructor(
    public languageService: LanguageService,
    private tenantConfigService: TenantConfigService,
  ) {
    this.defaultOpportunityImageUrl = this.tenantConfigService.tenant.defaultOpportunityImageUrl;
    this.tenantId = this.tenantConfigService.tenant.tenantId;
    this.opportunityTheme = this.tenantConfigService.tenant.opportunityTheme;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['opportunity'] && this.opportunity) {
      this.calculateDerivedData();
    }
  }

  private calculateDerivedData(): void {
    const isEn = this.languageService.currentLanguage === 'en';
    this.opportunityStatus = this.mapStatusToEnum(this.opportunity.fundStatus as unknown as string);
    this.shortFundType = this.opportunity.fundType === FundTypeEnum.CloseFund
      ? (isEn ? 'Close Fund' : 'صندوق مغلق')
      : (isEn ? 'Open Fund' : 'صندوق مفتوح');
    this.fundStatusLabel = this.getLabelForStatus(this.opportunity.fundStatus as unknown as string, isEn);
    const roi = this.opportunity.expectedTotalProfit;
    this.formattedRoi = (roi != null && !roi.toString().includes('%'))
      ? `${roi}%`
      : (roi?.toString() || '');

    const fundName = this.opportunity.fundNameWithMultiLine || this.opportunity.fundName || '';
    this.fundTitleFontSize = this.getScaledFontSize(1.35, fundName);
    this.classicFundTitleFontSize = this.getScaledFontSize(1.37, fundName);
  }

  private getScaledFontSize(baseRem: number, text: string): string {
    const length = text.replace(/\n/g, '').length;
    let scale = 1;
    if (length > 60) {
      scale = 0.55;
    } else if (length > 45) {
      scale = 0.65;
    } else if (length > 30) {
      scale = 0.8;
    } else if (length > 20) {
      scale = 0.9;
    }
    return `${(baseRem * scale).toFixed(2)}rem`;
  }

  private mapStatusToEnum(status: string): EFundStatus {
    switch (status) {
      case 'Active': return EFundStatus.Current;
      case 'Upcoming': return EFundStatus.Upcoming;
      case 'Ended':
      case 'Completed': return EFundStatus.Ended;
      default: return status as unknown as EFundStatus;
    }
  }

  private getLabelForStatus(status: string, isEn: boolean): string {
    switch (status) {
      case 'Active':
      case EFundStatus.Current as unknown as string:
        return isEn ? 'Active' : 'نشط';
      case 'Upcoming':
      case EFundStatus.Upcoming as unknown as string:
        return isEn ? 'Upcoming' : 'قادم';
      case 'Ended':
      case 'Completed':
      case EFundStatus.Ended as unknown as string:
        return isEn ? 'Ended' : 'منتهي';
      default:
        return status || '';
    }
  }
}